/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type SubCatalogsByCompanyIdQueryVariables = Exact<{
  companyId: string;
}>;


export type SubCatalogsByCompanyIdQuery = { sub_catalog: Array<{ id: string, name: string, supplier_company_id: string, sub_catalog_packagings: Array<{ id: string, packaging_sku: number }>, contracts: Array<{ buying_company: { tradeName: string, brand: Types.Brand_Enum | null } }> }>, packaging_aggregate: { aggregate: { count: number } | null } };


export const SubCatalogsByCompanyIdDocument = /*#__PURE__*/ gql`
    query SubCatalogsByCompanyId($companyId: uuid!) {
  sub_catalog(
    where: {supplier_company_id: {_eq: $companyId}}
    order_by: {name: asc}
  ) {
    id
    name
    supplier_company_id
    sub_catalog_packagings(where: {packaging: {id: {_is_null: false}}}) {
      id
      packaging_sku
    }
    contracts(
      where: {status: {_eq: SIGNED}}
      order_by: {buying_company: {tradeName: asc}}
    ) {
      buying_company {
        tradeName
        brand
      }
    }
  }
  packaging_aggregate(where: {company_id: {_eq: $companyId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSubCatalogsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useSubCatalogsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubCatalogsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubCatalogsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSubCatalogsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables> & ({ variables: SubCatalogsByCompanyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>(SubCatalogsByCompanyIdDocument, options);
      }
export function useSubCatalogsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>(SubCatalogsByCompanyIdDocument, options);
        }
// @ts-ignore
export function useSubCatalogsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>;
export function useSubCatalogsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubCatalogsByCompanyIdQuery | undefined, SubCatalogsByCompanyIdQueryVariables>;
export function useSubCatalogsByCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>(SubCatalogsByCompanyIdDocument, options);
        }
export type SubCatalogsByCompanyIdQueryHookResult = ReturnType<typeof useSubCatalogsByCompanyIdQuery>;
export type SubCatalogsByCompanyIdLazyQueryHookResult = ReturnType<typeof useSubCatalogsByCompanyIdLazyQuery>;
export type SubCatalogsByCompanyIdSuspenseQueryHookResult = ReturnType<typeof useSubCatalogsByCompanyIdSuspenseQuery>;
export type SubCatalogsByCompanyIdQueryResult = Apollo.QueryResult<SubCatalogsByCompanyIdQuery, SubCatalogsByCompanyIdQueryVariables>;